import React from "react";
import { Context } from "../Store";
import styles from "./ChristmasBanner.module.scss";
import { trackEvent } from "../utils/helpers";

const AnimText = ({ text }) => (
  <span className="btnText">
    <span>{text}</span>
  </span>
);

export default function ChristmasBanner() {
  const state = React.useContext(Context);
  let country = state.country;

  return (
    <div className={styles.christmasBanner}>
      <picture>
        {/* Match the tablet-wide breakpoint used for .christmasBannerImage sizing below */}
        <source
          media="(min-width: 1024px)"
          srcSet={`${country === "uk" ? `${process.env.PUBLIC_URL}/img/es_christmas_banner_bg.webp` : `${process.env.PUBLIC_URL}/img/es_us_stories_christmas_banner_desktop.webp`}`}
        />
        <img
          src={`${country === "uk" ? `${process.env.PUBLIC_URL}/img/es_christmas_banner_bg_mobile.webp` : `${process.env.PUBLIC_URL}/img/es_us_stories_christmas_banner_mobile.webp`}`}
          alt="Christmas foreground"
          className={styles.christmasBannerImage}
        />
        <div
          className={`${country === "uk" ? styles.christmasBoxWrapper : styles.christmasBoxWrapperUS} shareLinkWrapper`}
        >
          <div className={styles.christmasBoxContent}>
            <p className={styles.christmasTitle}>{country === "uk" ? "Christmas" : "Holidays"}</p>
            <p className={styles.christmasSubtitle}>at Electric Shuffle</p>
            <p className={styles.christmasDescription}>
              {country === "uk"
                ? "From festive team socials to the big winter catch-up with your mates, we've got you covered."
                : "From festive team socials to catching up with your crew, we've got you covered."}
            </p>
            <a
              href="https://electricshuffle.com/uk/christmas"
              target="_blank"
              rel="noreferrer"
              className={`shareLink ${styles.christmasButton}`}
              onClick={() => trackEvent("Next Visit", "start_a_booking")}
            >
              Find out more
            </a>
          </div>
        </div>
      </picture>
    </div>
  );
}
